import { Component, ElementRef, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stats',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('statsContainer') statsContainer!: ElementRef;

  stats = [
    { value: 0, target: 2000, suffix: '+', label: 'Registered Users' },
    { value: 0, target: 500, suffix: '+', label: 'AI Interviews' },
    { value: 0, target: 500, suffix: '+', label: 'Assessments Completed' },
    { value: 0, target: 20, suffix: '+', label: 'Students Placed' }
  ];

  private observer: any = null;
  private animated = false;

  ngAfterViewInit() {
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && !this.animated) {
          this.animateStats();
          this.animated = true;
        }
      }, { threshold: 0.1 });

      if (this.statsContainer) {
        this.observer.observe(this.statsContainer.nativeElement);
      }
    } else {
      // Fallback for SSR or older browsers
      this.animateStats();
    }
  }

  animateStats() {
    const duration = 2000;
    const steps = 60;
    const stepTime = Math.abs(Math.floor(duration / steps));

    this.stats.forEach(stat => {
      let currentStep = 0;
      const increment = stat.target / steps;

      const timer = setInterval(() => {
        currentStep++;
        stat.value = Math.min(Math.floor(increment * currentStep), stat.target);
        
        if (currentStep >= steps) {
          stat.value = stat.target;
          clearInterval(timer);
        }
      }, stepTime);
    });
  }

  ngOnDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
